/**
 * OPTIONS CATEGORIES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getOptionsCategories,
    getOptions,
    getOptionsCategory,
    printOptionsCategory,
    createOptionsCategories,
    updateOptionsCategories,
    deleteOptionsCategories,
} from "Core/configuration/options/config/api.options_categories";

const state = {
    page: {},
    form: {},
    options_categories: [],
    options: [],

    invoice_status: [],
    packing_list_status: [],
    nonconformance: [],
    organisation_types: [],
    machine_categories: [],
    rfq_status: [],
    purchase_order_status: [],
    fe_invoice_status: [],
    order_status: [],
    sales_units: [],
    uom_weights: [],
    quote_request_status: [],
    quote_status: [],
    payment_methods: [],
    bill_status: [],
    depreciation_methods: [],
    freight_terms: [],
    payment_status: [],

    selectedOptionsCategory: {
        category_id: null,
        company_id: "",
        options_category_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        options_category_details: [],
    },
    options_categories_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        status: "1",
    },
    rules_options_categories: {
        category_id: {
            name: "category_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        category: {
            name: "category",
            rules: "trim|max_length[45]|required",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        system_list: {
            name: "system_list",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        status: {
            name: "status",
            rules: "max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        options: {
            option_id: {
                name: "option_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            category_id: {
                name: "category_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            option: {
                name: "option",
                rules: "trim|max_length[65]|required",
                max_len: "65",
                min_len: "",
                default_value: "",
            },
            value: {
                name: "value",
                rules: "trim|max_length[65]",
                max_len: "65",
                min_len: "",
                default_value: "",
            },
            slug: {
                name: "slug",
                rules: "trim|max_length[65]",
                max_len: "65",
                min_len: "",
                default_value: "",
            },
            class: {
                name: "class",
                rules: "trim|max_length[36]",
                max_len: "36",
                min_len: "",
                default_value: "",
            },
            sort_by: {
                name: "sort_by",
                rules: "trim|max_length[1]|integer|required",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            sort_order: {
                name: "sort_order",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            status: {
                name: "status",
                rules: "trim|max_length[1]|integer|required",
                max_len: "1",
                min_len: "",
                default_value: "1",
            },
        },
    },
};

// getters
const getters = {
    options_categories: (state) => {
        return state.options_categories;
    },
};

// actions
const actions = {
    async fetchOptionsCategories({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getOptionsCategories({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                commit("mutate", {
                    property: "options_categories",
                    with: response.data.options_categories,
                });

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchOptions({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            // set default sort by = 2
            // 0 = option, 1 = value, 2 = sort_order
            body.sort_by = body.sort_by ? body.sort_by : "0";
            body.with_trashed = body.with_trashed ? body.with_trashed : "0";

            const response = await getOptions({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: body.slug,
                    with: response.data.options,
                });

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchOptionsCategory({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getOptionsCategory(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedOptionsCategory",
                    with: response.data.options_category,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printOptionsCategory({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printOptionsCategory(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveOptionsCategory({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["category_id"] === "undefined" || body["category_id"] == null || body["category_id"] == "") {
                delete body["category_id"];
                response = await createOptionsCategories({ body: body, headers: config.headers });
            } else {
                let category_id = body["category_id"];
                delete body["category_id"];
                response = await updateOptionsCategories({ body: body, headers: config.headers }, category_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteOptionsCategory({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteOptionsCategories(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetOptions(state) {
        state.page = {};
        state.form = {};
        state.options_categories = [];
        state.options = [];
        state.invoice_status = [];
        state.packing_list_status = [];
        state.nonconformance = [];
        state.organisation_types = [];
        state.machine_categories = [];
        state.rfq_status = [];
        state.purchase_order_status = [];
        state.fe_invoice_status = [];
        state.order_status = [];
        state.sales_units = [];
        state.uom_weights = [];
        state.quote_request_status = [];
        state.quote_status = [];
        state.payment_methods = [];
        state.bill_status = [];
        state.depreciation_methods = [];
        state.freight_terms = [];
        state.payment_status = [];
        state.selectedOptionsCategory = {
            category_id: null,
            company_id: "",
            options_category_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            options_category_details: [],
        };
        state.options_categories_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
            status: "1",
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
